import { useState } from 'react'
import { Input } from 'reactstrap'
import { isDisabled } from '../../utils'

export default function AppObjectFieldDate({ field, action, value, handleChange, hasChanged }) {
  console.log(`AppObjectFieldDate rendered: ${field.name} value: ${value}`)

  const [date, setDate] = useState(value)

  function handleDateChange(event) {
    setDate(event.target.value)
    handleChange(event, hasChanged)
  }

  if (isDisabled(action, field.behaviorType)) {
    let displayDate = date
    if (date.length === 10 && date[4] === '-') {
      // convert YYYY-MM-DD to MM-DD-YYYY
      displayDate = `${date.substr(5, 2)}-${date.substr(8, 2)}-${date.substr(0, 4)}`
    }
    return (<span>{displayDate}</span>)
  }
  return (
    <Input
      data-cy={`field-${field.id}`}
      type="date"
      name={field.id}
      bsSize="sm"
      style={{ width: 'auto' }}
      id={field.id}
      value={date}
      onChange={(event) => handleDateChange(event, hasChanged)}
    />
  )
}
